export function renderCreatePageImportsTemplate({
  singular,
  kebabName,
  singLabel
}: {
  singular: string
  kebabName: string
  singLabel: string
}): string {
  return `import { ${singular}Form } from '../${kebabName}-form'

export default function Create${singular}Page() {
  return <${singular}Form pageTitle="Create ${singLabel}" />
}
`
}
